const ShoppingListPlaceholder = () => {
  return (
    <section className="placeholder-glow pt-l">
      <div>
        <div className="text-center mb-4">
          <p className="placeholder">Twoja lista zakupów od 12.09.2023 do 19.09.2023</p>

          <div className="text-center mb-xl">
            <p className="title-small placeholder">Twoja lista</p>
            <p className="title-small placeholder">Twoja lista</p>
          </div>
        </div>

        <h3 className="title-large semi-bold d-none d-md-block placeholder w-100">&nbsp;</h3>
        <h3 className="title-medium semi-bold d-md-none placeholder w-100">&nbsp;</h3>
        <ul className="ingredients">
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
          <li className="placeholder w-100">&nbsp;</li>
        </ul>
      </div>
    </section>
  );
};

export default ShoppingListPlaceholder;
